/**
 * Auto-generated by yarn cross-type:gen-typescript. Do not edit by hand.
 *
 * @source dashboard/lib/shared/braze/remote_lookup/providers/purchase_remote_lookup_provider.rb
 * @owner @Appboy/messaging-experience
 */

import { emptyFiltersOutputSchema, emptyFiltersSchema } from "../../types/empty_filters.schemas";

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/purchase_remote_lookup_provider.rb) */
export const filtersTypeSchema = emptyFiltersSchema;

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/purchase_remote_lookup_provider.rb) */
export const filtersTypeOutputSchema = emptyFiltersOutputSchema;
